import { Show, TextField, DateField, NumberField, TabbedShowLayout } from 'react-admin';
import { MachineGroupsList } from './MachineGroupsList';
import { MachineBoardsList } from './MachineBoardsList';
import { MachinePrintingsList } from './MachinePrintingsList';

export const MachineShow = () => (
  <Show>
    <TabbedShowLayout>
      <TabbedShowLayout.Tab label="Summary">
        <NumberField source="id" />
        <TextField source="serial" />
        <DateField source="lastStarted" showTime />
        <DateField source="lastPrinting" showTime />
      </TabbedShowLayout.Tab>
      <TabbedShowLayout.Tab label="Groups" path="groups">
        <MachineGroupsList />
      </TabbedShowLayout.Tab>
      <TabbedShowLayout.Tab label="Boards" path="boards">
        <MachineBoardsList />
      </TabbedShowLayout.Tab>
      <TabbedShowLayout.Tab label="Printings" path="printings">
        <MachinePrintingsList />
      </TabbedShowLayout.Tab>
    </TabbedShowLayout>
  </Show>
);
